export const utcToLocal = (date) => {
  const utcDate = new Date(date);
  const timezoneOffset = utcDate.getTimezoneOffset();

  const localTimeInMillis = utcDate.getTime() - timezoneOffset * 60 * 1000;
  const localDate = new Date(localTimeInMillis);

  return localDate;
};
